module.exports = __webpack_public_path__ + "img/feature_c07.49087416.svg";